import { createSlice } from "@reduxjs/toolkit";

interface TriggersState {
    triggerAlertsRefresh: number;
    triggerLayerlistRefresh: number;
    triggerBoatLocationRefresh: number;
}

const initialState: TriggersState = {
    triggerAlertsRefresh: new Date().getTime(),
    triggerLayerlistRefresh: new Date().getTime(),
    triggerBoatLocationRefresh: new Date().getTime(),
};

const triggersSlice = createSlice({
    name: "scale",
    initialState,
    reducers: {
        triggerAlertsRefresh(state) {
            state.triggerAlertsRefresh = new Date().getTime();
        },
        triggerLayerlistRefresh(state) {
            state.triggerLayerlistRefresh = new Date().getTime();
        },
        triggerBoatLocationRefresh(state) {
            state.triggerBoatLocationRefresh = new Date().getTime();
        },
    },
});

export default triggersSlice.reducer;
export const { triggerAlertsRefresh, triggerLayerlistRefresh, triggerBoatLocationRefresh } = triggersSlice.actions;
export type { TriggersState };
